export type SSNErrorType = 'NaN' | 'invalidLength';

const cleanupSSN = (ssn: string) => ssn.replace(/\s/g, '');

const isNumeric = (ssn: string) => (Number.isNaN(Number.parseInt(ssn, 10)) ? 'NaN' : undefined);

const isCorrectLength = (ssn: string) => (ssn.length !== 11 ? 'invalidLength' : undefined);

export default (ssn: string, cleanupSpaces = false): SSNErrorType | boolean => {
    const cleanedSSN = cleanupSpaces ? cleanupSSN(ssn) : ssn;

    return isCorrectLength(cleanedSSN) ?? isNumeric(cleanedSSN) ?? true;
};
